import { asyncLocalStorage } from "./storage";
import { TOKEN, COMPANY_ID } from "../objects/constants";
import { clearStorage } from "./storage";

export const customFetch = async (
  resource: string,
  { headers, ...config }: RequestInit = {},
  multipart = false,
  fullUrl = false,
  forceToken?: string
) => {
  const token = (await asyncLocalStorage.getItem(TOKEN)) ?? forceToken;
  const companyID = await asyncLocalStorage.getItem(COMPANY_ID);

  // Ensure headers is always an object
  headers = headers || {};

  // Create a new headers object with type safety
  const newHeaders: Record<string, string> = {
    authorization: `Bearer ${token ?? ""}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...Object.fromEntries(
      Object.entries(headers).map(([key, value]) => [key, String(value)])
    ), // Ensure all header values are strings
  };

  // Add company-id header if companyID is valid
  if (companyID) {
    newHeaders["company-id"] = companyID;
  }
  if (!multipart) {
    newHeaders["Content-Type"] = "application/json";
  }
  try {
    const response = await fetch(
      fullUrl ? resource : `${process.env.REACT_APP_API_URL}/${resource}`,
      { ...config, headers: newHeaders }
    );
    if (response.status !== 200) {
      const respJson = await response.json();
      throw respJson.message ?? respJson.error;
    }

    return response;
  } catch (error) {
    if (error?.toString().includes("expired token")) {
      await clearStorage();
      window.location.href = "/login";
    }

    throw error;
  }
};
